module.exports = __webpack_public_path__ + "static/media/img-article-kids.f94fec76.png";